module.exports = __webpack_public_path__ + "static/btn 2_000016.4e6d622b.png";